/*
 * @Author: lijh(¯﹃¯*)
 * @Date: 2024-03-06 18:42:14
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-03-07 11:05:40
 * @Description: AES-128-CBC加密解密: key密钥,iv偏移量,mode模式CBC,padding填充方式Pkcs7
 */

import CryptoJS from "crypto-js";
// const CryptoJS = require('crypto-js')

// AES对称加密
export function encryptionValue(value, key = "sas6drf3", iv = "gfg65d5a") {
  value = value.toString(); // 数字加密会报错，转成字符串
  key = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  const encrypted = CryptoJS.AES.encrypt(value, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
// AES对称解密
export function decryptionValue(value, key = "sas6drf3", iv = "gfg65d5a") {
  key = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  const decrypt = CryptoJS.AES.decrypt(value, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypt.toString(CryptoJS.enc.Utf8);
}



// WEBPACK FOOTER //
// ./src/utils/CryptoJS.js